import React from 'react';
import { Table, Card, CardBody, Row, Col, Alert } from 'reactstrap';
import { connect } from 'react-redux';
import axios from "axios";
import { OBTENER_URL_SERVICIO } from "../constants/action-types";
import Sound from 'react-sound';

const mapStateToProps = state => {
  return { agente: state.agente };
};

class TablaTurnosAgente extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      cola: [],
      tablaDatos: [],
      cantidadTurnos: "0",
      sonido: false,
    };
    this.obtenerCola = this.obtenerCola.bind(this);
    this.actualizarCola = this.actualizarCola.bind(this);
  }

  componentDidMount() {
    this.obtenerCola();
  }

  async obtenerCola() {
    try {
      const response = await axios.get(OBTENER_URL_SERVICIO + "/traerListaServiciosAgentes/" + this.props.agente.areaAgente + "/" + this.props.agente.identificacionAgente);
      if (response.data.listaTurnosAgente.length > 0) {
        this.setState({
          cola: response.data.listaTurnosAgente,
          cantidadTurnos: response.data.listaTurnosAgente.length,
          sonido: true,
        })
        setTimeout(
          function () {
            this.actualizarCola();
          }
            .bind(this),
          10
        );
      }
      else {
        this.setState({
          cola: [],
        })
        setTimeout(
          function () {
            var conteo = 0;
            var lista = this.state.cola.map(p => {
              conteo = conteo + 1;
              return (
                <tr key={p.numeroTurno}>
                  <th scope="row">{conteo}</th>
                  <td>{p.numeroTurno}</td>
                  <td>{p.nombreUsuario}</td>
                  <td>{p.rolSeleccionado.rol}</td>
                  <td>{p.identificacionUsuario}</td>
                  <td>{p.servicioSeleccionado}</td>
                  <td>{p.estadoTurno}</td>
                </tr>
              )
            })
            this.setState({
              tablaDatos: lista,
              cantidadTurnos: 0,
              sonido: false,
            })
          }
            .bind(this),
          10
        );

        setTimeout(
          function () {
            this.obtenerCola();
          }
            .bind(this),
          7500
        );
      }
    } catch (error) {
      console.error(error);
    }
  }

  actualizarCola() {
    //Posicio, IDTurno, Solicitante, Rol, ID, Servicio, Estado
    /*<tr>
      <th scope="row">1</th>
      <td>IS-50</td>
      <td>Cristián López</td>
      <td>Estudiante</td>
      <td>506142010</td>
      <td>Cancelar Asignatura</td>
      <td>En Espera</td>
    </tr>*/
    var conteo = 0;
    var lista = this.state.cola.map(p => {
      conteo = conteo + 1;
      return (
        <tr key={p.numeroTurno}>
          <th scope="row">{conteo}</th>
          <td>{p.numeroTurno}</td>
          <td>{p.nombreUsuario}</td>
          <td>{p.rolSeleccionado.rol}</td>
          <td>{p.identificacionUsuario}</td>
          <td>{p.servicioSeleccionado}</td>
          <td>{p.estadoTurno}</td>
        </tr>
      )
    })


    this.setState({
      tablaDatos: lista,
    })

    setTimeout(
      function () {
        this.obtenerCola();
      }
        .bind(this),
      7500
    );
  }

  render() {
    let sonidoComp = "";
    if (this.state.sonido === true) {
      sonidoComp =
        <Sound
          url="https://notificationsounds.com/soundfiles/dd458505749b2941217ddd59394240e8/file-sounds-1111-to-the-point.mp3"
          playStatus={Sound.status.PLAYING}
        />
    }
    return (
      <Row>
        {sonidoComp}
        <Col lg={{ size: 12 }}>
          <Card>
            <CardBody>
              <Row>
                <Col lg={{ size: 6, offset: 3 }} md={{ size: 8, offset: 2 }} sm={{ size: 10, offset: 1 }} xs={{ size: 12 }}>
                  <Alert color="info">
                    <center>
                      Tienes {this.state.cantidadTurnos} Turnos por atender.
                  </center>
                  </Alert>
                </Col>
                <Col lg={{ size: 12 }}>
                  <Table striped bordered responsive>
                    <thead>
                      <tr>
                        <th>Cola</th>
                        <th>Turno</th>
                        <th>Solicitante</th>
                        <th>Rol</th>
                        <th>ID</th>
                        <th>Servicio</th>
                        <th>Estado</th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.state.tablaDatos}
                    </tbody>
                  </Table>
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Col>

      </Row>

    );
  }
}
export default connect(mapStateToProps)(TablaTurnosAgente);